import { Module, VuexModule, MutationAction, Action } from "vuex-module-decorators";
import { ServicesFactoryInstance } from "../../components/Controls/ServicesFactory";
import { JourFerieDto } from "../../dto/GenApi.iNotPaie.Dto/JourFerieDto";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Module({ namespaced: true })

class ParametersStore extends VuexModule {
	public storeVariableListeFonctions: ParametreDto[] = [];
	public storeVariableListeJoursFeries: JourFerieDto[] = [];

	@MutationAction({ mutate: ["storeVariableListeFonctions"] })
	public async fetchFonctions(): Promise<{ storeVariableListeFonctions: ParametreDto[] }> {
		const data = await ServicesFactoryInstance.ParametresService.getFonctions();

		return { storeVariableListeFonctions: data };
	}

	@MutationAction({ mutate: ["storeVariableListeJoursFeries"] })
	public async fetchJoursFeries(): Promise<{ storeVariableListeJoursFeries: JourFerieDto[] }> {
		const data = await ServicesFactoryInstance.JoursFeriesService.getJoursFeriesData();

		return { storeVariableListeJoursFeries: data };
	}

	/**
	 * @returns Promise<void>
	 */
	@Action
	public async initializeJoursFeries(): Promise<void> {
		// Si les données sont déjà chargées, ne rien faire
		if (this.storeVariableListeJoursFeries.length > 0) {
			return;
		}

		try {
			await this.context.dispatch("fetchJoursFeries");
		} catch (error) {
			NotificationServiceInstance.SendFailed(`Erreur lors de la récupération des jours fériés : ${(error as Error)}`);
			throw error;
		}
	}
}

export default ParametersStore;



// WEBPACK FOOTER //
// ./src/store/modules/ParametersStore.ts